$(document).ready(function() {

  // parallax effect
  $('.parallex-container').each(function() {
    new Parallax(this, {});
  });

  // gallery swiper
  $('.gallery-container').each(function(index, galleryElement) {
    const gallerySwiper = new Swiper($('.gallery-swiper-container .swiper', galleryElement)[0],
      {
        slidesPerView: "auto",
        navigation: {
          enabled: true,
          nextEl: $('.custom-swiper-button-next', galleryElement)[0],
          prevEl: $('.custom-swiper-button-prev', galleryElement)[0],
        },
      }
    );
    const previewSwiper = new Swiper($('.gallery-preview-swiper-container .swiper', galleryElement)[0], {
      slidesPerView: 1,
      effect: 'fade',
      pagination: {
        el: $('.swiper-pagination', galleryElement)[0],
        clickable: true,
      },
      navigation: {
        enabled: false,
      },
    });
    gallerySwiper.on('slideChange', function() {
      previewSwiper.slideTo(gallerySwiper.activeIndex);
      $('.swiper-slide', galleryElement).removeClass('active');
      $('.swiper-slide', galleryElement).eq(gallerySwiper.activeIndex).addClass('active');
    });
    previewSwiper.on('slideChange', function() {
      gallerySwiper.slideTo(previewSwiper.activeIndex);
      $('.swiper-slide', galleryElement).removeClass('active');
      $('.swiper-slide', galleryElement).eq(previewSwiper.activeIndex).addClass('active');
    });
    // On gallery thumbnail click, get the media id and slide to it
    $('.gallery-swiper-container .swiper-slide', galleryElement).each(function(index, slideEl) {
      $(slideEl).on('click', function() {
        var index = $(slideEl).index();
        previewSwiper.slideTo(index);
      });
    });
    window.addEventListener('variant:featured-media-id-change', function(event) {
      const { variantFeaturedMediaId } = event.detail;
      const index = $('[data-media-id="' + variantFeaturedMediaId + '"]', galleryElement).index();
      if (index !== -1) {
        previewSwiper.slideTo(index);
      }
    });
    const variantFeaturedMediaId = $('#selected-variant', galleryElement).data('variant-featured-media-id');
    if (variantFeaturedMediaId) {
      window.dispatchEvent(new CustomEvent('variant:featured-media-id-change', {
        detail: {
          variantFeaturedMediaId,
        },
      }));
    }
  });

  // About us swiper
  $('.swiper-container').each(function(_, swiperElement) {
    new Swiper($('.swiper', swiperElement)[0], {
      loop: true,
      autoplay: true,
      effect: 'fade',
      pagination: {
        el: $('.swiper-pagination', swiperElement)[0],
        clickable: true,
      },
      navigation: {
        enabled: false,
      },
    });
  });

  // header scroll effect
  let lastScrollTop = 0;
  const header = $('.header-wrapper');
  const scrollThreshold = 10;

  function handleScroll() {
    const currentScroll = $(window).scrollTop();
    if (window.innerWidth >=1024) {
      $('#mobile-menu').addClass('hidden');
      $('.button-menu').removeClass('open');
    }
    
    if (Math.abs(lastScrollTop - currentScroll) <= scrollThreshold)
      return;
      
    if (currentScroll > lastScrollTop && currentScroll > header.outerHeight()*3) {
      // Scrolling down
      header.css({
        'transform': 'translateY(-100%)',
        'transition': 'transform 0.3s'
      });
      $('#mobile-menu').addClass('hidden');
      $('.button-menu').removeClass('open');
    } else {
      // Scrolling up
      header.css({
        'transform': 'translateY(0)',
        'transition': 'transform 0.3s'
      });
    }
    
    lastScrollTop = currentScroll;
  }

  $(window).scroll(handleScroll);
  $(window).resize(handleScroll);

  // mobile menu
  $('#mobile-menu-button').on('click', function() {
    $('#mobile-menu').toggleClass('hidden');
    $('.button-menu').toggleClass('open');
  });

});
